
































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {ReceiptEmployeeParams} from "@/modules/receiptsexpenses/receiptemployee/params";
import {ReceiptEmployeeStore} from "@/modules/receiptsexpenses/receiptemployee/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {LadingPaymentType} from "@/enums/type";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import ReceiptEmployeeTable from "@/modules/receiptsexpenses/receiptemployee/List/ReceiptEmployeeTable/index.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {allDebtEmployee} from "@/modules/receiptsexpenses/receiptemployee/services";
import ReceiptEmployeeExcel from "@/modules/receiptsexpenses/receiptemployee/List/ReceiptEmployeeExcel/index.vue";
import TableToExcel from "@linways/table-to-excel";

@Component({
    name: "DebtEmployee",
    components: {ReceiptEmployeeExcel, ReceiptEmployeeTable, LadingPaymentTypeLabel, LadingStatusLabel, EmployeeSelector}
})
export default class extends mixins(CommonMixin) {
    params: ReceiptEmployeeParams = new ReceiptEmployeeParams();
    LadingPaymentType = LadingPaymentType;
    debtsReceiptEmployeeExcel = [] as any;
    isExporting = false;

    created() {
        ReceiptEmployeeStore.updateParamsDebtEmployee(this.params);
        ReceiptEmployeeStore.listDebtEmployee(ReceiptEmployeeStore.params);
    }

    @Watch("params", {deep: true})
    onChangeParams(val: any) {
        ReceiptEmployeeStore.updateParamsDebtEmployee({...val, page: 1});
        ReceiptEmployeeStore.listDebtEmployee(ReceiptEmployeeStore.params);
    }

    get debtEmployees() {
        return ReceiptEmployeeStore.ids.map((id: number) => ReceiptEmployeeStore.data[id]);
    }

    get pagination() {
        return {
            current: ReceiptEmployeeStore.meta.page,
            pageSize: ReceiptEmployeeStore.meta.limit,
            total: ReceiptEmployeeStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ReceiptEmployeeStore.updateParamsDebtEmployee({
            ...ReceiptEmployeeStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
        ReceiptEmployeeStore.listDebtEmployee(ReceiptEmployeeStore.params);
    }

    async exportExcel() {
        try {
            await this.getDataExport();
            setTimeout(() => {
                TableToExcel.convert(document.getElementById("table-excel-receipt-employee"), {
                    name: `Danh sách thu nhân viên.xlsx`,
                    sheet: {
                        name: "Sheet 1"
                    }
                });
            }, 200)
        } catch (e) {
        }
    }

    async getDataExport() {
        try {
            this.isExporting = true;
            const { data } = await allDebtEmployee(ReceiptEmployeeStore.params);
            this.debtsReceiptEmployeeExcel = data.datas;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xuất excel lỗi");
        } finally {
            this.isExporting = false;
        }
    }
}
